import { UserPlanFeature } from '@/users/domain/vo/IUserPlanResponse';

export const checkAccessByRegions = (
  currentRegionIds: string[],
  requiredRegionIds: string[],
): boolean => {
  const requiredSet = new Set(requiredRegionIds);

  return currentRegionIds.every((regionId) => requiredSet.has(regionId));
};

export const checkAccessByProducts = (
  currentProductIds: string[],
  requiredProductIds: string[],
): boolean => {
  const requiredSet = new Set(requiredProductIds);

  return currentProductIds.every((productId) => requiredSet.has(productId));
};

export const checkAccessByFeature = (
  currentFeatures: UserPlanFeature[] = [],
  requiredFeature: UserPlanFeature,
): boolean => {
  return currentFeatures.includes(requiredFeature);
};

export const checkAccess = (checks: boolean[]) => checks.every(Boolean);
